/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { onUnmounted } from '@vue/composition-api';
import { TinyEmitter } from 'tiny-emitter';

export const EventBus = new TinyEmitter();

export const enum EventBusEvent {
	DISCUSSION_CREATED = 'DISCUSSION_CREATED',
	FILES_UPLOADED = 'FILES_UPLOADED',
	LINK_SHARED = 'LINK_SHARED',
}

export interface EventBus {
	on(event: string, callback: Function, ctx?: any): void;
	once(event: string, callback: Function, ctx?: any): void;
	emit(event: string, ...args: any[]): void;
	off(event: string, callback?: Function): void;
}

export const useEventBus = (): EventBus => ({
	on(event: string, callback: Function, ctx?: any) {
		EventBus.on(event, callback, ctx);
		onUnmounted(() => {
			EventBus.off(event, callback);
		});
	},
	once(event: string, callback: Function, ctx?: any) {
		EventBus.once(event, callback, ctx);
		onUnmounted(() => {
			EventBus.off(event, callback);
		});
	},
	emit(event: string, ...args: any[]) {
		EventBus.emit(event, ...args);
	},
	off(event: string, callback?: Function) {
		EventBus.off(event, callback);
	},
});
